import { type DefaultTheme, type FlattenInterpolation, type ThemeProps, css } from 'styled-components';

export const getGeneralDatePickerStyle = (): FlattenInterpolation<ThemeProps<DefaultTheme>> => css`
  border-radius: 2px;
  width: 100%;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

  // vertically center clear/feedback icon
  .ant-input-clear-icon,
  .ant-form-item-feedback-icon {
    display: flex;
    align-items: center;
  }

  input {
    ::placeholder {
      color: ${({ theme }) => theme.color.grey.grey6};
    }
  }

  .ant-picker-suffix {
    color: ${({ theme }) => theme.color.grey.grey9};
  }

  :hover {
    .ant-picker-suffix {
      color: ${({ theme }) => theme.color.grey.grey11};
    }
  }
`;
